import { JobFormDialog } from '@/components/jobs/JobFormDialog'
import AgendaPage from '@/pages/jobs/AgendaPage'
import JobDetailPage from '@/pages/jobs/JobDetailPage'

interface JobFormPageProps {
  mode: 'create' | 'edit'
}

export default function JobFormPage({ mode }: JobFormPageProps) {
  return (
    <>
      {mode === 'edit' ? <JobDetailPage /> : <AgendaPage />}
      <JobFormDialog mode={mode} />
    </>
  )
}
